import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { firefly, paradigmLightBlue } from '@paradigm/design-system/src/colors';
import { useDrfqOrderbook } from '@paradigm/features/src/unified-rfqs/contexts/drfqs';
import { useDrfqRfq } from '@paradigm/features/src/unified-rfqs/ui/rfq-context';
import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';
import { ActionCell } from '#/components/rfq-common/ActionButtons';
import { RfqActionRow } from '#/components/UnifiedRfqs/rfqs/action/common';
import { getUserTicker } from '@paradigm/store/auth';
import { renderSecondaryRows } from '../Orderbook';
import PrimaryOrdersRow from '../PrimaryOrdersRow';
import { ScreenPriceAndHiddenOrderContainer } from '../quote-builder/ScreenPriceAndHiddenOrderContainer';

export function OrderbookDetailsModal() {
  const rfq = useDrfqRfq();
  const userDesk = useSelector(getUserTicker)!;
  const [bids, asks] = useDrfqOrderbook(rfq.id);
  const filteredBids = bids.filter(
    (bid) => bid.desk !== userDesk && bid.type !== 'HIDDEN',
  );
  const filteredAsks = asks.filter(
    (ask) => ask.desk !== userDesk && ask.type !== 'HIDDEN',
  );

  const [firstBid, ...remainingBids] = filteredBids;
  const [firstAsk, ...remainingAsks] = filteredAsks;

  const secondaryRows = renderSecondaryRows({
    bids: remainingBids,
    asks: remainingAsks,
    ordersLength: 3,
    rfqId: rfq.id,
  });

  return (
    <OrderBook>
      <OrderbookContainer>
        <RfqActionHeader />
        <PrimaryOrdersRow
          ask={firstAsk}
          bid={firstBid}
          isExpanded
          isViewDetails
        />
        {secondaryRows}
      </OrderbookContainer>

      <ScreenPriceAndHiddenOrderContainer />
    </OrderBook>
  );
}

function RfqActionHeader() {
  return (
    <RfqActionRowStyled>
      <ActionCell>Qty</ActionCell>
      <ActionCell />
      <ActionCell>Bid</ActionCell>
      <span />
      <ActionCell>Ask</ActionCell>
      <ActionCell />
      <ActionCell>Qty</ActionCell>
    </RfqActionRowStyled>
  );
}

const OrderBook = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    align-self: start;
    > * {
      min-width: 0;
    }
  }
`;

const OrderbookContainer = styled.div`
  background-color: ${firefly};
  margin: 0;
  border-radius: 3px;
`;

const RfqActionRowStyled = styled(RfqActionRow)`
  background: none;
  height: 32px;
  color: ${paradigmLightBlue};
`;
